<div class="main-wrapper d-flex align-items-center justify-content-center">
  <button mat-flat-button class="lang-btn" (click)="changeLanguage()">
    {{ 'general.language' | translate }}
  </button>
  <div class="card">
    <div class="logo-container">
      <img src="./assets/images/logos/logo.svg" alt="">
    </div>
    <div class="card-content">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
